var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"treemap-container"},[_c('apexchart',{attrs:{"type":"treemap","height":_vm.chartHeight,"options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }